import { businessLoginDTO } from "../../interfaces/businessInterface";
import { ResponseDTO } from "../../interfaces/response";
import HttpService from "../function/http";

export class BusinessServices {
    private _http = new HttpService()

    public async businessLogin(dataBody: businessLoginDTO): Promise<ResponseDTO> {
        const response: ResponseDTO = await this._http.post(
            `${process.env.REACT_APP_API_URL}`,
            `/Auth/business/login`,
            dataBody
        )
        return response
    }

    public async businessPasswordValidate(dataBody: businessLoginDTO): Promise<ResponseDTO> {
        const response: ResponseDTO = await this._http.post(
            `${process.env.REACT_APP_API_URL}`,
            `/Auth/business/password/validate`,
            dataBody
        )
        return response
    }

    public async businessPasswordRecovery(dataBody: businessLoginDTO): Promise<ResponseDTO> {
        const response: ResponseDTO = await this._http.post(
            `${process.env.REACT_APP_API_URL}`,
            `/Auth/business/password/recovery`,
            dataBody
        )
        return response
    }

    public async businessPasswordChange(dataBody: businessLoginDTO, accessToken: string): Promise<ResponseDTO | any> {
        const response: ResponseDTO = await this._http.postToken(
            accessToken,
            `${process.env.REACT_APP_API_URL}`,
            `/Auth/business/password/reset`,
            dataBody
        )
        return response
    }
}